/**
 * Decides whether an empty element list should hide the module's list area.
 *
 * The `showWhenEmpty` flag is the ACF setting `vis_hvis_tom`
 * ("Vis oversigten, hvis den er tom"), carried through the API as
 * SearchView::hideIfEmpty. Despite that name it means *show* when empty.
 *
 * Hiding is about modules that hold nothing at all — those should not take up
 * space on the page. A search that happens to match nothing is a search
 * result, not an empty module: it gets the empty-list message, and the filter
 * panel always stays put so the visitor can correct the search.
 */
export interface EmptyListVisibilityInput {
  /** The module's unfiltered dataset holds at least one element. */
  moduleHasElements: boolean;
  /** ACF `vis_hvis_tom`: keep the overview visible even when it holds nothing. */
  showWhenEmpty: boolean;
}

export function shouldHideElementList({
  moduleHasElements,
  showWhenEmpty,
}: EmptyListVisibilityInput): boolean {
  return !moduleHasElements && !showWhenEmpty;
}
